<template>
  <div class="TeamAssetItemCover">
    <img
      v-if="isTypeImage"
      class="card-img-top TeamAssetItemCover__image"
      :src="teamAsset.real_url"
      :alt="teamAsset.title"
      crossorigin="anonymous"
    >

    <div
      v-if="isTypeDoc"
      class="d-flex justify-content-center align-items-center h-100 border-bottom"
    >
      <i
        class="fa-solid TeamAssetItemCover__doc"
        :class="`fa-${icon}`"
      ></i>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useTeamAssetItem } from './use-team-asset-item'

export default {
  name: 'TeamAssetItemCover',
  setup () {
    const { teamAsset, isTypeImage, isTypeDoc } = useTeamAssetItem()
    const icon = computed(() => {
      const url = teamAsset.value?.real_url
      if (url) {
        const extension = url.split('.').pop()
        switch (extension) {
          case 'pdf':
            return 'file-pdf'
          case 'doc':
          case 'docx':
            return 'file-word'
          case 'ppt':
          case 'pptx':
            return 'file-powerpoint'
          case 'xls':
          case 'xlsx':
            return 'file-spreadsheet'
        }
      }

      return 'file'
    })

    return {
      teamAsset,
      icon,
      isTypeImage,
      isTypeDoc
    }
  }
}
</script>

<style lang="scss" scoped>
.TeamAssetItemCover {
  &__image {
    object-fit: cover;
    height: 100%;
  }

  &__doc {
    font-size: 48px;
    color: var(--gray-dark);
  }

  .fa-file-spreadsheet {
    color: #0c6c37;
  }

  .fa-file-powerpoint {
    color: #027b80;
  }

  .fa-file-word {
    color: #1b5abf;
  }

  .fa-file-pdf {
    color: #f91101
  }
}
</style>
